import { useRef, useEffect, useState, type ReactNode } from "react";

interface ScrollRevealCardProps {
  children: ReactNode;
  index?: number;
}

export const ScrollRevealCard = ({ children, index = 0 }: ScrollRevealCardProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.1, rootMargin: "50px" }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className="transition-all duration-500 ease-out"
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)",
        transitionDelay: isVisible ? `${Math.min(index * 40, 200)}ms` : "0ms",
      }}
    >
      {children}
    </div>
  );
};
